module.exports = __webpack_public_path__ + "c07f3bb333e0ba6b7f9ca829db097f5a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/TestimonialBlock/components/Testimonial/images/ic_quotation.svg
// module id = 1363
// module chunks = 3